import React, { useEffect, useState } from "react";
import { Checkbox, Form, message, Row, Col, Skeleton } from "antd";
import { trans, SelectWithSearch, InputText, AddNewButton } from "@comps/components"
import { makeRequest, getErrorProps, makeRequestStateless } from "@utils/helpers";
import { getRelatedDataReq, updateMultipleShiftsReq, updateSingleShift } from "../requests";
import { Commons, Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import CreateTimeSlot from "../../timeSlots/components/CreateTimeSlot";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { rosterTooltips } from "../../common/rosterTooltips";
import SingleRosterModal from "../../common/SingleRosterModal";

const langKey = Const["companyRoaster"].lngKey

const fieldLabel = makeFieldLabel(rosterTooltips.shift, { namespace: "shift", label: (key) => trans(`${langKey}.${key}`) });
const formName = "updateReason";


const UpdateShift = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [childComponent, setChildComponent] = useState(null);
  const [loading, setloading] = useState(true);
  const [form] = Form.useForm();
  useEffect(() => {
    getRemoteData()
    setFormData()
    // eslint-disable-next-line
  }, []);
  const getRemoteData = () => {
    makeRequestStateless(getRelatedDataReq, null, ongetRelatedDataReq, null);
  }
  const ongetRelatedDataReq = (response) => {
    setTimeSlots(createSelectList(response.time_slots))
    setloading(false)
  }
  const setFormData = () => {
    if (!props.shift) {
      return;
    }
    form.setFieldsValue(
      {
        date: props.shift.date,
        time_slot_id: props.shift.time_slot_id,
        is_full_overtime_shift: props.shift.is_full_overtime_shift,
      }
    )
  }
  const onSubmit = (data) => {
    let payload={};

if(props.multiple){
  payload = {
    shift: {
      ids: props.shiftIds,
      time_slot_id: data.time_slot_id,
      is_full_overtime_shift: data.is_full_overtime_shift,
    },
   filters:props.filters,
   page:props.page
}

makeRequest(setLoader, updateMultipleShiftsReq, payload, onSuccess, onError);
}
else{
  payload = {
   shift: {
     id: props.shift.id,
     date: data.date,
     time_slot_id: data.time_slot_id,
     is_full_overtime_shift: data.is_full_overtime_shift,
     employment_id: props.shift.employment_id
   },
   filters:props.filters,
   page:props.page
 }
 payload.id = props.shift.id;
 makeRequest(setLoader, updateSingleShift, payload, onSuccess, onError);
}

   
    setSaveLoader(true)
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Record Updated");
    props.getAllData(data);
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  const onTimeSlotCreated = (data) => {
    if (data.length) {
      setTimeSlots(createSelectList(data))
      form.setFieldValue('time_slot_id', data[0].id)
    }
    setChildComponent(null);
  }
  return (
    <SingleRosterModal
      title={ props.multiple ? "Update Rosters" : <>{ trans(Commons.update) } Roster</> }
      formName={ formName }
      saving={ saveLoader || loader }
      disabled={ props.disabled }
      onCancel={ () => props.onCreated(false) }
    >
      <Skeleton loading={ loading } active>
        <Form
          { ...formLayout }
          form={ form }
          id={ formName }
          name={ formName }
          onFinish={ onSubmit }
          disabled={ props.disabled }
        >
          <Row gutter={ 20 } align="top" className="single-roster-form-row">
            { !props.multiple &&
              <Col lg={ 11 } md={ 11 } sm={ 24 } xs={ 24 }>
                <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date", trans(`${langKey}.date`)) }
                  className="da-mb-0"
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <InputText disabled />
                </Form.Item>
              </Col> }

            <Col lg={ props.multiple ? 24 : 13 } md={ props.multiple ? 24 : 13 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="time_slot_id" rules={ rules.time_slot_id } label={ fieldLabel("time_slot_id", trans(`${langKey}.time_slot_id`)) }
                  className="da-mb-0"
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <SelectWithSearch
                    options={ timeSlots }
                    placeholder={ trans(`${langKey}.time_slot_id`) }
                  />
                </Form.Item>
                <AddNewButton className="create-roster-add-slot" text="Time Slot" onClick={ () => setChildComponent(<CreateTimeSlot onCreated={ onTimeSlotCreated } />) } />
              </div>
            </Col>

            <Col span={ 24 }>
              <Form.Item name="is_full_overtime_shift" rules={ rules.is_full_overtime_shift } label={ fieldLabel("is_full_overtime_shift", trans(`${langKey}.is_full_overtime_shift`)) }
                className="da-mb-0 single-roster-checkbox"
                { ...getErrorProps(errors['name']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Skeleton>
      { childComponent }
    </SingleRosterModal>
  )
}

export default UpdateShift

const rules = {
  name: [
    { required: true, message: 'Please enter name' },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
